var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('el-container',[_c('meauLeft'),_c('el-container',[_c('el-header',{staticClass:"headMenu",attrs:{"height":"50px"}},[_c('meauTop')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }